import type { HttpTypes } from "@medusajs/types";
import { useCallback } from "react";
import { toCheckoutAddress } from "@/pages/checkout/resolve-addresses";
import type { useUpdateCartsAddresses } from "@/queries/cart/mutations";
import type { InlineAddressData } from "@/pages/checkout/validations";

/**
 * Handle real-time billing address changes during checkout.
 * Updates the cart billing address when user selects a different billing address.
 *
 * No phone override, matching what `resolveCheckoutAddresses` writes for
 * billing at submit: the form's phone is the delivery contact number, not this
 * address's.
 */
export function useBillingAddressChange({
  cartIds,
  updateAddressesMutation
}: {
  cartIds: string[];
  updateAddressesMutation: ReturnType<typeof useUpdateCartsAddresses>;
}) {
  return useCallback(
    (address: HttpTypes.StoreCustomerAddress | InlineAddressData) => {
      updateAddressesMutation.mutate({
        cartIds,
        billingAddress: toCheckoutAddress(address)
      });
    },
    [cartIds, updateAddressesMutation]
  );
}
